var map = {
	"./en-us": 18765,
	"./en-us.ts": 18765,
	"./i18n-setup": 50227,
	"./i18n-setup.ts": 50227
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	var id = map[req];
	return __webpack_require__(id);
});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 49620;
module.exports = webpackAsyncContext;